
import { i18nText } from '@/locales';

import {Component, Prop, Vue} from "vue-property-decorator";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import {serviceCreateTabs} from "@/utils/tabs";
import ServiceCosmetologistLayout from "@/UI/components/forms/serviceCreate/ServiceCosmetologistLayout.vue";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {IServicesCategory} from '@/entity/servicesCategory/services.category.types';
import {ServicesCategoryStore} from "@/store/modules/ServicesCategory";
import {WorkersStore} from "@/store/modules/Workers";
import {IWorkers, IWorkersListItem} from "@/entity/workers/workers.types";
import {SalaryStore} from "@/store/modules/Salary";
import {StatusesStore} from "@/store/modules/Status";
import {PositionStore} from "@/store/modules/Position";
import {CategoryStore} from "@/store/modules/Category";
import {IPosition} from "@/entity/position/position.types";
import {IStatus} from "@/entity/status/status.types";
import {ISalaryScheme} from "@/entity/salaryScheme/salaryScheme.types";
import {ICms_Category} from '@/entity/staff/staff.types'
import moment from 'moment';
import {checkUserRole} from '@/router/Lib/helper';
import ServiceProductsModalForm from "@/UI/components/forms/serviceGeneral/ServiceProductsModalForm.vue";
import {ConsumableStore} from "@/store/modules/Consumables";
import {ConsumablesTypeForm} from "@/form/serviceGeneral/serviceGeneralProductsCreate";
import {ServiceStore} from "@/store/modules/Services";
import ServiceNomenclatureCreateForm from "@/form/service/serviceNomenclatureCreate";
import {ServicesCategoryNomenclatureStore} from "@/store/modules/ServicesCategoryNomenclature";
import {
  IServicesCategoryNomenclature
} from "@/entity/servicesCategoryNomenclature/services.category.nomenclature.types";
import {ServiceNomenclatureStore} from "@/store/modules/ServicesNomenclature";
import {getStudioId} from "@/UI/lib/state";

@Component({
  components: {
    FormGroup,
    ServiceCosmetologistLayout,
    PageTitle,
    ServiceProductsModalForm
  },
  methods: {
    moment,
    checkUserRole
  }
})

export default class ServiceCreateFormComponent extends Vue {
  @Prop() form!: ServiceNomenclatureCreateForm;

  price_first: any = 0
  price_second: any = 0
  tabs = serviceCreateTabs;
  time: moment.Moment | undefined = moment('00:00', 'HH:mm');
  visible: boolean;
  staffAdded: Record<string, any>[];
  worker: IWorkersListItem | null = null;
  forms = new ConsumablesTypeForm()
  showProducts = false
  price_firstobj = {}
  price_secondobj = {}
  message_price_cosmetologist: any = {}
  message_price_top_cosmetologist: any = {}
  route = this.$route.name

  constructor() {
    super();
    this.visible = false;
    this.staffAdded = [];
  }

  show(staff: IWorkersListItem): void {
    this.worker = staff;
  }

  handlePriceChange(): void {
    this.$emit('clearError');
    if (this.form.price_first < this.message_price_cosmetologist.first
        || this.form.price_first > this.message_price_cosmetologist.second) {
      this.$emit('setError', 'price_first', i18nText("Цена вне диапазона"));
    }
    if (this.form.price_second > this.message_price_top_cosmetologist.second
        || this.form.price_second < this.message_price_top_cosmetologist.first) {
      this.$emit('setError', 'price_second', i18nText("Цена вне диапазона"));
    }

  }

  async trackingForm(): Promise<void> {
    if (this.$route.name === 'ServiceUpdate' || this.$route.name === 'PartnerServiceUpdate') {
      if (this.form.name) {
        await this.fetchPrice()
        this.price_firstobj = {
          required: true,
          min: this.message_price_cosmetologist.first,
          max: this.message_price_cosmetologist.second,
          message:
              `Это поле обязательно к заполнению, цены в одном городе не должны различаться более чем на 10%, укажите цену от
                        ${this.message_price_cosmetologist.first}₽ до
                        ${this.message_price_cosmetologist.second}₽`,
          trigger: 'change',
          type: 'number'
        }
        this.price_secondobj = {
          required: true,
          min: this.message_price_top_cosmetologist.first,
          max: this.message_price_top_cosmetologist.second,
          message:
              `Это поле обязательно к заполнению, цены в одном городе не должны различаться более чем на 10%, укажите цену от
                        ${this.message_price_top_cosmetologist.first}₽ до
                        ${this.message_price_top_cosmetologist.second}₽`,
          trigger: 'change',
          type: 'number'
        }
      }
    } else {
      this.price_firstobj = {
        required: true,
        message: i18nText("Это поле обязательно к заполнению"),
        trigger: 'change',
      }
      this.price_secondobj = {
        required: true,
        message: i18nText("Это поле обязательно к заполнению"),
        trigger: 'change',
      }
    }
  }

  async fetchPrice(): Promise<void> {
    if (this.$route.name === 'ServiceUpdate') {
      await ServiceNomenclatureStore.fetchAll({
        filter: {
          name: this.form.name,
          category_id: this.form.category_id,
        }
      })
      this.price_first = ServiceNomenclatureStore.services?.data[0].price_first
      this.price_second = ServiceNomenclatureStore.services?.data[0].price_second
    } else {
      await ServiceStore.fetchAll({
        filter: {
          name: this.form.name,
          category_id: this.form.category_id,
          salon_id: getStudioId(this)
        }
      })
      this.price_first = ServiceStore.service?.data[0].price_first
      this.price_second = ServiceStore.service?.data[0].price_second
    }
    this.message_price_cosmetologist = {
      first: parseInt(this.price_first) - parseInt(this.price_first) / 10,
      second: parseInt(this.price_first) + parseInt(this.price_first) / 10,
    }
    this.message_price_top_cosmetologist = {
      first: parseInt(this.price_second) - parseInt(this.price_second) / 10,
      second: parseInt(this.price_second) + parseInt(this.price_second) / 10,
    }
  }

  get rules(): Record<string, any> {
    return {
      price_first: [this.price_firstobj],
      price_second: [this.price_secondobj]
    }
  }

  // addProducts(): void {
  //     this.showProducts = true
  // }

  async onSubmitProducts(): Promise<void> {
    try {
      this.forms.service_id = parseInt(this.$route.params['category_id'])
      this.forms.product_list[0].quantity = 22
      await ConsumableStore.create(this.forms)
    } catch (e) {
      console.log(e)
    } finally {
      this.showProducts = false
    }
  }

  showStaff(): void {
    //var staff = WorkersStore.workers!.data;
    this.visible = false;
  }

  showModal(): void {
    this.visible = true;
  }

  handleOk(): void {
    this.visible = false;
  }

  handleCancel(): void {
    this.visible = false;
  }

  // deletedWorker(id: number): void {
  //     let staff = WorkersStore.workers ? WorkersStore.workers.data : [];
  //     for (let i = 0; i < staff.length; i++) {
  //         if (id == staff[i].id) {
  //             delete staff[i];
  //         }
  //     }
  // }

  handleTimeChange(value: moment.Moment): void {
    if (value) {
      this.time = value;
      this.form.service_duration = value.format('HH:mm');
    }
  }

  // async deleteWorker(id: number): Promise<void> {
  //     if ((await WorkersStore.delete(id)).status) {
  //         message.success('Сотрудник успешно удален');
  //         await WorkersStore.fetchAll({limit: 10, filter: {salon_id: parseInt(this.$route.params.id)}});
  //     } else {
  //         message.error('Что то пошло не так...')
  //     }
  // }

  get servicesCategory(): IServicesCategoryNomenclature | null {
    return ServicesCategoryNomenclatureStore.items
  }

  get servicesCategoryPartner(): IServicesCategory | null {
    return ServicesCategoryStore.serviceCategory
  }

  //get serviceWorkersColumns(): ITableColumn[] { return TablesStore.serviceWorkersColumns;}
  //get serviceDetailProductsColumns(): ITableColumn[] { return TablesStore.serviceDetailProductsColumns }
  //get staffLoaded(): boolean { return WorkersStore.workersLoaded }
  get staff(): IWorkers | null {
    return WorkersStore.workers
  }

  get positions(): IPosition[] {
    return PositionStore.position
  }

  get statuses(): IStatus[] {
    return StatusesStore.status
  }

  get categories(): ICms_Category[] {
    return CategoryStore.category
  }

  get salary(): ISalaryScheme[] {
    return SalaryStore.salary
  }

  async created(): Promise<void> {
    const checkRole = Vue.auth.check('owner');
    let filter = {limit: 200, filter: {}};
    if (!checkRole) {
      filter.filter = {'salon_id': 0, 'is_parent': true}
      await ServicesCategoryNomenclatureStore.fetchAll({limit: 200})
    } else {
      await ServicesCategoryNomenclatureStore.fetchAll(filter)
    }
    await this.trackingForm()
    //TODO: Ошибка
    //TODO: Скрыл лишние запросы
    //await WorkersStore.fetchAll({limit: 200});
    //await StatusesStore.fetchAll();
    //await CategoryStore.fetchAll();
    //await PositionStore.fetchAll();
    //await SalaryStore.fetchAll();
    //this.workerForm.setFormDataWithoutId(this.positions, this.categories, this.statuses, this.salary);
  }
}
